module.exports = __webpack_public_path__ + "static/media/vw-t30.ecba634d.jpg";